module.exports = __webpack_public_path__ + "static/media/ccj.6b039951.svg";